export function cleanupReservedRegExpSymbols(text: string) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, " ");
}
